module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/User-fca4e6a4373fc030692e56d489aec593.svg";